import type { RetirementCalculatorOutputs } from '@fruitful/financial-calculators';
import React from 'react';

import { GroveSimpleModal } from '../../common/components/GroveSimpleModal';
import { RetirementContributionsSimulationTable } from './RetirementContributionsSimulationTable';

interface RetirementContributionsSimulationModalProps {
    outputs: RetirementCalculatorOutputs;
    onSelectAmount: (amount: number) => void;
    isOpen: boolean;
    onClose: () => void;
}

export const RetirementContributionsSimulationModal = ({
    outputs,
    onSelectAmount,
    isOpen,
    onClose,
}: RetirementContributionsSimulationModalProps) => {
    return (
        <GroveSimpleModal isOpen={isOpen} onClose={onClose}>
            <RetirementContributionsSimulationTable
                outputs={outputs}
                onSelectAmount={(amount) => {
                    onSelectAmount(amount);
                    onClose();
                }}
            />
        </GroveSimpleModal>
    );
};
